import * as React from "react"

const IconDowload = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      d="M4.414 16.563a.938.938 0 0 0 .938.937h9.375a.937.937 0 1 0 0-1.875H5.351a.938.938 0 0 0-.938.938Zm.39-9.063h1.485V3.75a1.25 1.25 0 0 1 1.25-1.25h5a1.25 1.25 0 0 1 1.25 1.25V7.5h1.445a.938.938 0 0 1 .664 1.599l-4.975 5.01a1.251 1.251 0 0 1-1.771 0L4.139 9.098A.938.938 0 0 1 4.803 7.5Z"
      fill="#432EFF"
    />
  </svg>
)

export default IconDowload
